import { Record } from "immutable";
import { Nullable } from "common/types";

export const orgMetadataFromJSON = (json: IOrgMetadata) => {
  const recordData: IOrgMetadataRecord = { ...(json as any) };

  return new OrgMetadataRecord(recordData);
};

export interface IOrgMetadata {
  email_address?: string;
  legal_name?: string;
  phone_number_2?: string;
  phone_number_3?: string;
  license_number?: string;
}

export interface IOrgMetadataRecord {
  email_address?: Nullable<string>;
  legal_name?: Nullable<string>;
  phone_number_2?: Nullable<string>;
  phone_number_3?: Nullable<string>;
  license_number?: Nullable<string>;
}

export const defaultOrgMetadataProps = {
  email_address: null,
  legal_name: null,
  phone_number_2: null,
  phone_number_3: null,
  license_number: null,
} as IOrgMetadataRecord;

export class OrgMetadataRecord extends Record(defaultOrgMetadataProps) {}
